export default __webpack_public_path__ + "static/media/neq.272c0765.svg";